export function NumberAnchor({ value, label }: { value: string; label: string }) {
  return (
    <div className="flex flex-col gap-1">
      <div className="font-display font-normal text-l-ink-deep text-5xl md:text-6xl leading-none tracking-tight tabular-nums">
        {value}
      </div>
      <div className="font-sans text-l-ink-muted text-sm">{label}</div>
    </div>
  );
}
